<template>
  <dialog-base>
    <div class="mod-login">
      <div class="title">
        欢迎参加小安城市寻宝记<br>请先登录噢
      </div>
      <div class="form">
        <div class="form-control">
          <input type="text"
                 class="form-input"
                 v-model="form.phone"
                 placeholder="请输入你的手机号码"
                 maxlength="11"
                 @blur="onblur">
        </div>
        <div class="form-control">
          <input type="text"
                 class="form-input code"
                 v-model="form.code"
                 placeholder="请输入验证码"
                 maxlength="6"
                 @blur="onblur">
          <div class="btn-send"
               @click="getCode">
            发送验证码<span v-if="isBanGet">({{time}})</span>
          </div>
        </div>
      </div>
      <div class="btn-red"
           @click="tapSubmit">
        <span class="text">确定</span>
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
import {
  apiSmsCode
} from '@/api/sms'
import { apiTreasureHuntCheckInUser } from '@/api/treasure-hunt'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      form: {},
      time: 60,
      isBanGet: false,
      isGetting: false
    }
  },
  mounted() {
    this.$stat({
      event: 'view_inputphone'
    })
  },
  methods: {
    verify() {
      if (!this.form.phone || this.form.phone.length !== 11) {
        this.$toast('请输入正确的手机号码')
        return false
      }
      if (!this.form.code) {
        this.$toast('请输入短信验证码')
        return false
      }
      return true
    },
    async getCode() {
      if (this.isBanGet || this.isGetting) {
        return
      }
      if (!this.form.phone || this.form.phone.length !== 11) {
        this.$toast('请输入正确的手机号码')
        return false
      }
      try {
        const { randstr, ticket } = await this.$captcha.showCaptcha()
        this.isGetting = true
        this.$loading()
        await apiSmsCode({
          phone: this.form.phone,
          randstr,
          ticket
        })
        this.isBanGet = true
        this.computeTime()
        this.$toast.clear()
        this.$toast('验证码发送成功')
      } catch (error) {
        this.$toast.clear()
        this.$toast(error.message || '验证码发送失败')
      }
      this.isGetting = false
    },
    computeTime() {
      setTimeout(() => {
        if (this.time - 1 <= 0) {
          this.isBanGet = false
          return this.resetTime()
        }
        this.time--
        this.computeTime()
      }, 1000)
    },
    resetTime() {
      this.time = 60
    },
    async tapSubmit() {
      if (!this.verify()) {
        return
      }
      this.$loading()
      try {
        const { data: { status, message } } = await apiTreasureHuntCheckInUser(this.form)
        this.$toast.clear()
        if (status === 0) {
          this.$toast(message)
          return
        }
        this.close()
        this.onOk && this.onOk()
      } catch (error) {
        this.$toast.clear()
        this.$toast('请求数据失败')
      }
    },
    onblur() {
      window.scrollTo(0, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-login {
  padding: 220px 120px 85.4px;
  width: 723px;
  height: 833px;
  background-image: url("~@/assets/dialog/dialog-login.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  .title {
    margin: auto;
    text-align: center;
    font-size: 42px;
    font-weight: bold;
    color: #f57906;
  }
  .form {
    margin-top: 39px;
    .form-control {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 28px;
      padding-bottom: 8px;
      width: 479px;
      height: 95px;
      background-image: url("~@/assets/ico/btn-white.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      &:nth-child(n + 2) {
        margin-top: 32px;
      }
      .form-input {
        width: 100%;
        height: 100%;
        font-size: 32px;
        font-weight: 500;
        background-color: transparent;
        &.code {
          width: 210px;
        }
      }
      .btn-send {
        text-align: center;
        flex: 1;
        font-size: 32px;
        color: #ea5404;
      }
    }
  }
  .btn-red {
    margin-top: 53px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 479px;
    height: 95px;
    background-image: url("~@/assets/ico/btn-red.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    .text {
      font-size: 32px;
      font-weight: 700;
      color: #ffffff;
      text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
        #872c0c 0 -2px 2px;
    }
  }
}
</style>
